import React, { useEffect, useState } from 'react';
import { HeaderComponent } from '@zawarski/palmetto-ui-components';
import { IconButton, useTheme } from '@mui/material';
import useStyles from './ModalNoParcel.styles.ts';
import { Button, Modal, TextField, Typo } from 'components/primitive';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { Nullable } from 'interfaces/Nullable.ts';

type ModalNoParcelProps = {
  isOpen: boolean;
  parcelID?: Nullable<string>;
  onClose: () => void;

  callBack: (parcelID: string) => void;
};

const ModalNoParcel: React.FC<ModalNoParcelProps> = ({ callBack, isOpen, onClose, ...props }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const [parcelID, setParcelID] = useState<string>(props.parcelID ?? '');

  useEffect(() => {
    setParcelID(props.parcelID ?? '');
  }, [props.parcelID]);

  const handleClose = () => {
    onClose();
  };

  const handleAdd = () => {
    callBack(parcelID);
    onClose();
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setParcelID(e.target.value);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <>
        <HeaderComponent
          title='Parcel Information'
          icon={
            <IconButton onClick={() => handleClose()}>
              <CloseIcon className='icon' />
            </IconButton>
          }
        />
        <Box sx={classes.content}>
          <Typo>You may enter a Parcel Record ID.</Typo>
          <TextField
            fullWidth
            label='Parcel ID'
            value={parcelID}
            onChange={onChange}
            placeholder='Enter Parcel ID'
          />
        </Box>
        <Box sx={classes.footer}>
          <Box sx={classes.footerWrapper}>
            <Button fullWidth neutral onClick={onClose} sx={{ color: theme.palette.grey[500] }}>
              Cancel
            </Button>
            <Button fullWidth onClick={() => handleAdd()}>
              Add
            </Button>
          </Box>
        </Box>
      </>
    </Modal>
  );
};

export default ModalNoParcel;
